import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  // Keyed by teamId. Value is the override payload, or null when none exists.
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
